import styled from '@emotion/styled';
import {fontSize} from 'patient-ping-remedy/packages/theme';

const Wrapper = styled.div`
    display: grid;
    grid-template-areas:
    "left-aside header"
    "left-aside page-nav"
    "left-aside main";
    grid-template-rows: 6rem auto 1fr;
    grid-template-columns: 8rem 1fr;
    grid-row-gap: 0;
    grid-column-gap: 0;
    font-size: ${fontSize.standard};
    min-height: 100dvh;
    height: 100%;
    width: 100%;
`;

const Header = styled.div`
    grid-area: header;
    z-index: 3;
`;

const PageNav = styled.div`
    grid-area: page-nav;
    z-index: 1;
`;

const Main = styled.div`
    grid-area: main;
    display: flex;
    flex-direction: column;
    overflow: auto;
`;

const LeftAside = styled.div`
    grid-area: left-aside;
`;

export { Wrapper, Header, PageNav, LeftAside, Main };
